import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ListingsFilterComponent,
  ListingsPaginatorComponent,
} from '@out-web/components';
import { FilterObject, IListing, ListingsService, SeoService } from '@out-web/core';
import { FormsModule } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ListingCardComponent } from '@out-web/components';
import { ListingSkeletonComponent } from '@out-web/components';

@Component({
  selector: 'out-listings.component',
  imports: [
    CommonModule,
    ListingsFilterComponent,
    ListingsPaginatorComponent,
    FormsModule,
    ListingCardComponent,
    ListingSkeletonComponent,
  ],
  templateUrl: './listings.component.html',
  styleUrl: './listings.component.css',
})
export class ListingsComponent implements OnInit {
  listings: IListing[] = [];
  isLoading = false;
  isSkeletonLoad = false;
  sortSelected = 'created DESC';
  skipListings = 0;
  totalListings = 0;

  filters: FilterObject = {};

  sortOptions = [
    {
      label: 'Date: New to old',
      value: 'created DESC',
    },
    {
      label: 'Date: Old to new',
      value: 'created ASC',
    },
    {
      label: 'Price: High to low',
      value: 'price.value DESC',
    },
    {
      label: 'Price: Low to high',
      value: 'price.value ASC',
    },
    {
      label: 'Mileage: High to low',
      value: 'vehicle.mileage DESC',
    },
    {
      label: 'Mileage: Low to high',
      value: 'vehicle.mileage ASC',
    },
  ];

  constructor(
    private seoService: SeoService,
    private listingsService: ListingsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.setMetaData();
    this.filters = { ...this.route.snapshot.queryParams };
    this.sortSelected = this.filters['OrderBy'] || 'created DESC';
    this.loadListings(this.filters);
    this.CallListingStates();
  }

  private CallListingStates() {
    this.listingsService.listingsState$.subscribe((state) => {
      this.isLoading = state.listingPending;
      this.isSkeletonLoad =
        !state.listings.search.listings.length && state.listingPending;
      this.listings = state.listings.search.listings;
      this.totalListings = state.totalListings;
      this.skipListings = state.skipListings;
    });
  }

  private setMetaData(): void {
    const title = 'Browse Used Tesla For Sale Listings | Sell Your Tesla | Only Used Tesla';
    const description = 'Browse a wide range of certified pre-owned Teslas available for sale at Only Used Tesla. Find the perfect used Tesla for you, from Model 3 to Model S, Model Y, and more!';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/used-tesla-for-sale?OrderBy=created+DESC&Skip=0&Top=9';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }

  loadListings(filters: FilterObject) {
    const updatedFilters = { ...filters };
    this.listingsService
      .fetchListings(
        updatedFilters as { [key: string]: string | number },
        'search',
        true
      )
      .subscribe({
        next: () => {
          this.replaceState(updatedFilters);
        },
        error: (err) => {
          console.error('Error loading listings:', err);
        },
      });
  }

  onSortChange(sortValue: string) {
    this.sortSelected = sortValue;
    this.listingsService.setSortListings(sortValue);
    const currentFilters = this.getCurrentFilters();
    this.loadListings(currentFilters);
  }

  replaceState(filters: FilterObject) {
    const params = new URLSearchParams();
    params.set('OrderBy', this.sortSelected);
    params.set('Skip', this.skipListings.toString());
    params.set('Top', '9');

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        params.set(key, filters[key] as string);
      }
    });

    window.history.pushState({}, '', `${window.location.pathname}?${params}`);
  }

  private getCurrentFilters(): FilterObject {
    const filters: FilterObject = {};
    const params = this.route.snapshot.queryParams;

    Object.keys(params).forEach((key) => {
      if (key !== 'OrderBy' && params[key] !== 'ALL_OPTIONS') {
        filters[key] = params[key];
      }
    });

    return filters;
  }

  clearFilters = () => {
    window.location.href =
      '/used-tesla-for-sale?OrderBy=created+DESC&Skip=9&Top=9';
  };
}
